import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/EventPage.css";

/*
  Converted from the original PHP/HTML page.
  Image paths assume your images live in:
  E:\vanakkam\vanakkam\client\public\assets\images\...
  In React (CRA/Vite), anything inside /public is served from the root,
  so every image below is referenced as "/assets/images/xxx.png".
  If you use Vite and keep assets in src instead of public, swap these
  for imports.
*/

const IMG = "/assets";

export default function EventPage() {
   const navigate = useNavigate();
  /* ---------------- Countdown ---------------- */
  const [time, setTime] = useState({ days: "00", hours: "00", minutes: "00", seconds: "00" });
  const [circles, setCircles] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [eventStarted, setEventStarted] = useState(false);

  useEffect(() => {
    const eventDate = new Date("August 29, 2026 00:00:00").getTime();
    const radius = 40;
    const circumference = 2 * Math.PI * radius;

    const tick = () => {
      const now = new Date().getTime();
      const distance = eventDate - now;

      if (distance < 0) {
        setEventStarted(true);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTime({
        days: String(days).padStart(2, "0"),
        hours: String(hours).padStart(2, "0"),
        minutes: String(minutes).padStart(2, "0"),
        seconds: String(seconds).padStart(2, "0"),
      });

      const offset = (value, max) => circumference * ((max - value) / max);

      setCircles({
        days: offset(days % 365, 365),
        hours: offset(hours, 24),
        minutes: offset(minutes, 60),
        seconds: offset(seconds, 60),
      });
    };

    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);

  /* ---------------- Agenda dropdowns ---------------- */
  // Only one dropdown open at a time, matching the original script's final behavior.
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleSub = (id) => {
    setOpenDropdown((prev) => (prev === id ? null : id));
  };

  const cellClass = (id) => `topic-cell${openDropdown === id ? " open active" : ""}`;
  const subClass = (id) => `sub-content${openDropdown === id ? " open" : ""}`;

  const Chevron = () => (
    <svg
      className="dropdown-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );

  return (
    <>
      {/* Hero Section */}
      <section className="hero-section" id="hero"style={{
    backgroundImage: `url(${IMG}/hero_event_1.jpg)`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}>
        <div className="hero-content-event">
          <div className="container">
            <div className="hero-text">
              <h1 className="hero-title-event">
  India HR Confluence 2026
</h1>

              <p className="hero-subtitle-event">
                Getting India HR Community Ready for the{" "}
                <span className="highlight-text">HR Confluence</span>
              </p>

              <p className="hero-description">Celebrating people, culture, and the future of work</p>

              <div className="event-details1">
                <span className="event-date">
                  29 August, 2026 |
                  <img src={`${IMG}/location.png`} alt="Location Icon" className="location-icon" />
                  Dr.N.G.P. Arts and Science College, Coimbatore
                </span>
              </div>

              <div className="cta-container">
                <a href="#tickets" className="cta-button">
                  <img src={`${IMG}/get.png`} alt="Ticket Icon" className="cta-icon" />
                  <span>Register Now</span>
                </a>
              </div>
            </div>

            <div className="countdown-card">
              <div className="countdown-container" id="countdown">
                {eventStarted ? (
                  <h2>Event Started!</h2>
                ) : (
                  <>
                    <CountdownItem label="Days" value={time.days} offset={circles.days} circleId="days-circle" />
                    <CountdownItem label="Hours" value={time.hours} offset={circles.hours} circleId="hours-circle" />
                    <CountdownItem label="Minutes" value={time.minutes} offset={circles.minutes} circleId="minutes-circle" />
                    <CountdownItem label="Seconds" value={time.seconds} offset={circles.seconds} circleId="seconds-circle" />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Festival Stats */}
      <section className="festival-stats-section">
        <div className="container">
<h2 className="festival-heading">
  India's Most Valuable HR Confluence 2026.
</h2>

<div className="festival-heading-line"></div>

          <div className="festival-stats-grid">
            <StatCard iconClass="stat-icon1" icon="day_icon.png" number="01" label="Day" />
            <StatCard iconClass="stat-icon2" icon="session_1.png" number="2+" label="Sessions" />
            <StatCard iconClass="stat-icon3" icon="industry_1.png" number="10+" label="Indutry Experts" />
            <StatCard iconClass="stat-icon4" icon="panel_discuss.png" number="2+" label="Panel Discussion" />
            <StatCard iconClass="stat-icon5" icon="attendees.png" number="300+" label="Attendees" />

            <div className="stat-card">
              <div className="stat-icon6">
                <img src={`${IMG}/value.png`} alt="Day" />
              </div>
              <div className="stat-text6">
                <strong>Value</strong>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About */}
      <section className="about-festival-section">
        <div className="container">
          <div className="about-grid">
            <div className="event-about-left">
              <div className="about-left-inner">
                <img src={`${IMG}/about.png`} alt="About HR Festival" className="about-image" />
                <div className="about-text">
                  <div className="about-tag-wrap">
                    <span className="about-tag">About</span>
                  </div>
                  <div className="about-title-wrap">
                    <h2 className="about-title">
                      HR Confluence 2026
                    </h2>
                  </div>
                </div>
              </div>
            </div>

            <div className="event-about-right">
              <p>
                India HR Confluence 2026 is where HR leaders, business executives, and people professionals come together to exchange ideas, discover emerging trends, and shape the future of work
              </p>
              <p>
                Experience a day filled with visionary keynotes, thought-provoking panel discussions, and meaningful networking with industry experts.
              </p>
              <p>
               Join 300+ HR professionals to learn, connect, and build future-ready organizations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Highlights */}
      <section className="festival-highlights-section">
        <div className="container">
          <div className="highlights-grid">
            <HighlightCard img="keynote_speeches.png" title="Keynote Speeches" />
            <HighlightCard img="expert_talks.png" title="Expert Talks" />
            <HighlightCard img="panel_discussions.png" title="Panel Discussion" />
            
            <HighlightCard img="networking.png" title="Networking" />
           
          </div>
        </div>
      </section>

      {/* Event Themes */}
      <section className="event-themes-section">
        <div className="container">
          <h2 className="themes-heading">The Event Themes</h2>
<div className="themes-heading-line"></div>

          <div className="themes-grid">
     <div className="theme-card">
  <div className="theme-header">
    <div className="theme-icon-placeholder">
      <img src={`${IMG}/event_icon_1.png`} alt="Event Icon" className="theme-icon" />
    </div>

    <h3 className="theme-title">
      The Human Advantage: Leading the AI-Powered Workforce
    </h3>
  </div><ul className="theme-points1">
  <li>
    <img src={`${IMG}/Vecor.png`} alt="" className="bullet-icon" />
    <span>Unlock human potential through leadership, learning, and innovation.</span>
  </li>

  <li>
    <img src={`${IMG}/Vecor.png`} alt="" className="bullet-icon" />
    <span>Leverage intelligent technologies to transform HR and business.</span>
  </li>

  <li>
    <img src={`${IMG}/Vecor.png`} alt="" className="bullet-icon" />
    <span>Build agile, resilient, and high-performing organizations.</span>
  </li>
</ul>
            </div>

            

            <div className="theme-card">
              <div className="theme-header">
  <div className="theme-icon-placeholder">
    <img src={`${IMG}/event_icon_3.png`} alt="Event Icon" className="theme-icon" />
  </div>

  <h3 className="theme-title">
    Shaping the Future of Work: People, Purpose & Possibilities
  </h3>
</div>
              <ul className="theme-points3">
  <li>
    <img src={`${IMG}/Vecor.png`} alt="" className="bullet-icon" />
    <span>Create inclusive, engaging, and employee-centric workplaces.</span>
  </li>

  <li>
    <img src={`${IMG}/Vecor.png`} alt="" className="bullet-icon" />
    <span>Foster meaningful work, culture, and impactful leadership.s.</span>
  </li>

  <li>
    <img src={`${IMG}/Vecor.png`} alt="" className="bullet-icon" />
    <span>Prepare organizations with skills, innovation, and adaptability.</span>
  </li>
</ul>
            </div>
          </div>
        </div>
      </section>

      {/* Why this festival matters */}
      <section className="why-festival-section">
       <div
    className="why-overlay"
    style={{
      backgroundImage: `url(${IMG}/why_background.jpg)`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    }}
  ></div>
        <div className="container">
          <div className="why-grid">
            <div className="why-left">
              <h2 className="why-heading">
  Why this HR Confluence
  <br />
  <span>truly matters</span>

  <img
    src={`${IMG}/why_hr_tick.png`}
    alt=""
    className="why-tick"
  />
      <img
        src={`${IMG}/mobiles.png`}
        alt=""
        className="why-mobile-icon"
      />
              </h2>
            </div>

            <div className="why-right">
              <WhyPill icon="power.png" text="Power of Community" />
              <WhyPill icon="impact.png" text="Impactful Speakers" />
              <WhyPill icon="closer.png" text="Closer Networking Opportunities" />
              <WhyPill icon="innovation.png" text="Innovation & Future HR Trends" />
              <WhyPill icon="influence.png" text="Impact & Influence at Scale" />
              <WhyPill icon="inspiring.png" text="Inspiration That Lasts Long" />
              <WhyPill icon="who_new.png" text={'Interact with the "Who\'s Who" of HR'} />
              <WhyPill icon="optimize.png" text="High Energy & Optimism" />
              <WhyPill icon="effect.png" text="The HR Festival Effect" />
              <WhyPill icon="action.png" text="Actionable Frameworks" />
            </div>
          </div>
        </div>
      </section>

   {/* 

<section
  className="founder-section"
  style={{
    backgroundImage: `url(${IMG}/ceo_background.png)`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  }}
>
  
  <div className="founder-overlay"></div>

  <div className="container">
    <div className="founder-grid">
     
      <div className="founder-left">
        <p className="founder-quote">
          India's largest HR event focused on making HR professionals future-ready through insight,
          innovation, and community.
        </p>

        <h3 className="founder-name">Rajeshwaran P</h3>
        <p className="founder-role">Founder &ndash; Vanakkam HRD</p>

        
        <div className="founder-socials">
          
            href="https://www.linkedin.com/in/rajeshwaran-p-%F0%9F%87%AE%F0%9F%87%B3-235266141/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={`${IMG}/found_linkedin.png`} alt="LinkedIn" />
          </a>
          <a href="https://www.instagram.com/_rajeshwaran_p?igsh=NTU1cTY3N293aHhl" target="_blank" rel="noreferrer">
            <img src={`${IMG}/found_link_1.png`} alt="LinkedIn" />
          </a>
        </div>
      </div>

      
      <div className="founder-right">
        <img src={`${IMG}/rajesh_founder.png`} alt="Rajeshwaran P" />
      </div>
    </div>
  </div>
</section>


<section className="chief-guest-section" id="chief-guests">
  <div className="container">
    <h2 className="spk-heading">Chief Guests</h2>

    <div className="chief-guest-grid">
      
      <div className="spk-card">
        <div className="spk-photo">
          <img src={`${IMG}/arunraju.jpeg`} alt="Speaker Name" />
        </div>
        <div className="spk-info">
          <h3 className="spk-name">Dr. K.G. Arunraj</h3>
          <p className="spk-role">Hon'ble Minister for Health, Medical Education and Family Welfare</p>
          <p className="spk-company">Government of Tamil Nadu</p>
        </div>
      </div>

     
      <div className="spk-card">
        <div className="spk-photo">
          <img src={`${IMG}/tvk.jpeg`} alt="Speaker Name" />
        </div>
        <div className="spk-info">
          <h3 className="spk-name">D. Sarath Kumar</h3>
          <p className="spk-role">Hon'ble Minister for Human Resources Management</p>
          <p className="spk-company">Government of Tamil Nadu</p>
        </div>
      </div>
    </div>
  </div>
</section>
*/}


<section className="spk-section" id="speakers">
  <div className="container">
    <h2 className="spk-heading">Speakers</h2>

    <div className="spk-grid">
      <SpeakerCard
  linkedin="https://linkedin.com/in/ethiraj-s-901a4312"
  photo="sp_2.jpeg"
  name="Ethiraj S"
  role="Senior Manager HR"
  company="Artizent"
/>
      <SpeakerCard
        linkedin="https://linkedin.com/in/sasikumar-thangamuthu"
        photo="sp_3.jpeg"
        name="Sasikumar Thangamuthu"
        role="Laughter Therapy"
        // company="Brand Architect"
      />
      <SpeakerCard
  linkedin="https://www.linkedin.com/in/jkavitha23"
  photo="sp_4.jpeg"
  name="Kavitha Jagadeesan "
  role="Director, Global Employer Services"
  company="Deloitte India"
/>

<SpeakerCard
  linkedin="https://www.linkedin.com/in/rani-sapthika-65740958"
  photo="sp_1.jpeg"
  name="Rani Sapthika "
  role="Deputy Director HR"
  company="Integra Global Solutions"
/>
{/*
<SpeakerCard
  linkedin="https://www.linkedin.com/in/satishrajarathnam"
  photo="Speakers/Evnt_spk26_02.jpeg"
  name="Satish Rajarathnam"
  role="Enterprise Visionary, Talent Architect, Agripreneur & Author"
  company="Milam Group"
/>

<SpeakerCard
  linkedin="https://www.linkedin.com/in/dhinakarjacob"
  photo="Speakers/Evnt_spk26_03.jpeg"
  name="Dhinakar Selwyn"
  role="Vice President & Global Head-Transformation"
  company="Capgemini Technologies"
/>

<SpeakerCard
  linkedin="https://www.linkedin.com/in/arunprakashm"
  photo="Speakers/Evnt_spk26_04.PNG"
  name="Arun Prakash"
  role="Founder & CEO"
  company="HCL GUVI"
/>

<SpeakerCard
  linkedin="https://www.linkedin.com/in/ssathyaprakash"
  photo="Speakers/sathya.jpeg"
  name="Sathya Prakash Sekaran"
  role="Director - HR"
  company="Ziffity Solutions"
/>

<SpeakerCard
  linkedin="https://www.linkedin.com/in/dineshkumarannadurai"
  photo="Speakers/din.jpeg"
  name="Dineshkumar Annadurai"
  role="Founder & CEO"
  company="Biran Technologies, (Emerging AI & ML software & tools provider)"
/>

<SpeakerCard
  linkedin="https://www.linkedin.com/in/rajendran"
  photo="Speakers/Evnt_spk26_05.jpeg"
  name="Rajendran Dandapani"
  role="Director - Zoho Corporation"
  company="President - Zoho Schools of Learning"
/>

<SpeakerCard
  linkedin="https://www.linkedin.com/in/dr-srk"
  photo="Speakers/Evnt_spk26_06.jpeg"
  name="Dr.Subramani Ramakrishnan"
  role="Vice President"
  company="UPS India Technology Centre"
/>

<SpeakerCard
  linkedin="https://www.linkedin.com/in/lavanya-nandakumar-37115946"
  photo="Speakers/Evnt_spk26_07.jpeg"
  name="Lavanya Nandakumar"
  role="VP & Global Head of Talent Supply Chain"
  company="Prodapt"
/>

<SpeakerCard
  linkedin="https://www.linkedin.com/in/ravindran-chandrasekaran"
  photo="Speakers/ravindran.jpeg"
  name="Ravindran Chandrasekaran"
  role="Senior Director - GCC Strategy and Operations"
  company="Ashley Furniture India"
/>

<SpeakerCard
  linkedin="https://www.linkedin.com/in/sangeethabala"
  photo="Speakers/sange.jpg"
  name="Sangeetha Bala"
  role="Founder & CEO"
  company="Thinkinfinity Technology"
/>

<SpeakerCard
  linkedin="https://www.linkedin.com/in/udaya-sankar-5ab28031"
  photo="Speakers/udai.jpeg"
  name="V Udaya Sankar"
  role="Director, Nasscom Talent Council, Co-Founder"
  company="Maatram Foundation"
/>
*/}
    </div>
  </div>
</section>



      {/* ===== Event Agenda Section — paste this inside your existing page/component ===== */}
      <section className="agenda-section">
        <div className="agenda-container">
          <h2 className="agenda-heading">
            Event Agenda
            <span className="agenda-heading-underline"></span>
          </h2>

          <div className="agenda-list">
            {/* Header row */}
            <div className="agenda-row agenda-row-header">
              <div className="agenda-cell agenda-cell-time header-pill">Time</div>
              <div className="agenda-cell agenda-cell-topic header-pill">Topic</div>
              <div className="agenda-cell agenda-cell-speaker header-pill">
                Speaker / Panel Discussion
              </div>
            </div>

            {/* Registration */}
            <div className="agenda-row">
              <div className="agenda-cell agenda-cell-time time-pill-dark">
                9:00 AM to 10:00 AM
              </div>
              <div className="agenda-cell agenda-cell-topic topic-pill-dark">
                Registration
              </div>
            </div>

            {/* Welcome Address */}
            <div className="agenda-row">
              <div className="agenda-cell agenda-cell-time time-pill-light">
                10:00 AM to 10:15 AM
              </div>
              <div className="agenda-cell agenda-cell-topic topic-pill-light">
                Welcome Address and Lighting Lamp
              </div>
            </div>

            {/* Keynote Session */}
            <div className="agenda-row">
              <div className="agenda-cell agenda-cell-time time-pill-light">
                10:20 AM to 10:50 AM
              </div>
              <div className="agenda-cell agenda-cell-topic topic-pill-light">
                Keynote Session
              </div>
            </div>

            {/* Culture as Strategy — has a Panel Discussion box */}
            <div className="agenda-row">
              <div className="agenda-cell agenda-cell-time time-pill-light">
                11:00 AM to 12:45 PM
              </div>
              <div className="agenda-cell agenda-cell-topic topic-pill-light topic-cell-split">
                Culture as Strategy: Building High-Trust Organizations
              </div>
              <div className="agenda-cell agenda-cell-speaker speaker-pill">
                Panel Discussion
              </div>
            </div>

            {/* Networking Lunch */}
            <div className="agenda-row">
              <div className="agenda-cell agenda-cell-time time-pill-dark">
                01:00 PM - 02:00 PM
              </div>
              <div className="agenda-cell agenda-cell-topic topic-pill-dark">
                Networking Lunch
              </div>
            </div>

            {/* Laughter Therapy Session */}
            <div className="agenda-row">
              <div className="agenda-cell agenda-cell-time time-pill-light">
                2:00 PM to 3:00 PM
              </div>
              <div className="agenda-cell agenda-cell-topic topic-pill-light">
                Laughter Therapy Session
              </div>
            </div>

            {/* Vote of Thanks */}
            <div className="agenda-row">
              <div className="agenda-cell agenda-cell-time time-pill-dark">
                3:00 PM
              </div>
              <div className="agenda-cell agenda-cell-topic topic-pill-dark">
                Vote of Thanks
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tickets */}
      <section className="ticket-section" id="tickets">
        <div className="container">
          <h2 className="ticket-heading">Secure Your HR Confluence Pass.</h2>
          <p className="ticket-subtitle">Get Ready for the Future of HR</p>
          <p className="ticket-note">
            
          </p>

          <div className="ticket-card">
            <h3 className="ticket-type">Complimentary pass</h3>
            

            <ul className="ticket-features">
              <li>
        
 <img
    src={`${IMG}/vector.png`}
    alt=""
    className="tick-icon"
  />
                <span className="feature-text-event">1 Day Event Pass</span>
              </li>
              <li>
                <img
    src={`${IMG}/vector.png`}
    alt=""
    className="tick-icon"
  />
                <span className="feature-text-event">Full access to all insightful sessions</span>
              </li>
              <li>
                <img
    src={`${IMG}/vector.png`}
    alt=""
    className="tick-icon"
  />
                <span className="feature-text-event">Meaningful Networking over lunch &amp; tea</span>
              </li>
              <li>
                <img
    src={`${IMG}/vector.png`}
    alt=""
    className="tick-icon"
  />
                <span className="feature-text-event">Meet Select speakers &amp; Industry Icons</span>
              </li>
              <li>
                <img
    src={`${IMG}/vector.png`}
    alt=""
    className="tick-icon"
  />
                <span className="feature-text-event">E-Certificate of Participation</span>
              </li>
            </ul>

          <button className="ticket-btn" onClick={() => navigate("/eventform")}>
  <img src={`${IMG}/get.png`} alt="Ticket Icon" className="ticket-icon" />
  <span>Register Now</span>
</button>
          </div>
        </div>
      </section>

      
      <>
  <section className="partners-section">
    <div className="container">
      <h2 className="partners-heading-event title-sponsor-heading">
        EXCLUSIVE <span>PARTNER</span>
      </h2>
      <div className="partners-grid title-sponsor-grid">
        <a  target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
          <div className="partner-card">
            <img src={`${IMG}/out.png`} alt="Title Sponsor" />
          </div>
        </a>
      </div>

      {/* <h2 className="partners-heading-event platinum-heading">
        PLATINUM <span>SPONSOR</span>
      </h2>
      <div className="platinum-grid">
        <a href="https://go.vmg-connect.com/" target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
          <div className="partner-card">
            <img src={`${IMG}/pla.png`} alt="Platinum Sponsor" />
          </div>
        </a>
      </div> */}

      {/* <h2 className="partners-heading-event gold-heading">
        GOLD <span>SPONSORS</span>
      </h2>
      <div className="partners-grid gold-grid">
        <a href="https://www.keka.com/" target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
          <div className="partner-card">
            <img src={`${IMG}/gold.png`} alt="Gold Sponsor" />
          </div>
        </a>
        <a href="https://veril.ai/" target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
          <div className="partner-card">
            <img src={`${IMG}/veril.png`} alt="Gold Sponsor" className="veril-logo" />
          </div>
        </a>
      </div> */}

      {/* <div className="container">
        <h2 className="partners-heading-event silver-sponsor-heading">
          SILVER <span>SPONSORS</span>
        </h2>
        <div className="partners-grid silver-sponsor-grid">
          <a href="https://aecsalem.edu.in/" target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
            <div className="partner-card">
              <img src={`${IMG}/silver.png`} alt="Silver Sponsor" />
            </div>
          </a>
          <a href="https://www.voltechgroup.com/" target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
            <div className="partner-card">
              <img src={`${IMG}/vol.png`} alt="Silver Sponsor" />
            </div>
          </a>
          <a href="https://rvscas.ac.in/" target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
            <div className="partner-card">
              <img src={`${IMG}/rvscas.png`} alt="Silver Sponsor" />
            </div>
          </a>
        </div>
      </div> */}

      {/* <h2 className="partners-heading-event training-partner-heading">
        ASSESSMENT &amp; TRAINING <span>PARTNER</span>
      </h2>
      <div className="partners-grid training-partner-grid">
        <div className="partner-card">
          <img src={`${IMG}/ass.png`} alt="Assessment & Training Partner" />
        </div>
      </div> */}

      {/* <h2 className="partners-heading-event associate-heading">
        ASSOCIATE <span>SPONSORS</span>
      </h2>
      <div className="associate-grid">
        <PartnerLink href="https://karpagam.edu.in/" img="karpagam.png" />
        <PartnerLink href="https://npsbcet.edu.in/" img="new.png" />
        <PartnerLink href="https://alphagroup.edu/" img="alpha.png" />
        <PartnerLink href="https://www.axis.bank.in/" img="axis.png" />
        <PartnerLink href="https://kiot.ac.in/" img="know.png" />
        <PartnerLink href="https://egspec.org/" img="pillay.png" imgClass="ens-logo" />
        <PartnerLink href="https://saveetha.ac.in/" img="savee.png" imgClass="ens-logo" />
      </div> */}

      {/* <h2 className="partners-heading-event gold-exhibitors-heading">
        GOLD <span>EXHIBITORS</span>
      </h2>
      <div className="partners-grid gold-exhibitors-grid">
        <div className="partner-card">
          <img src={`${IMG}/safe.png`} alt="Gold Exhibitor" />
        </div>
      </div> */}

      {/* <h2 className="partners-heading-event silver-exhibitors-heading">
        SILVER <span>EXHIBITORS</span>
      </h2>
      <div className="partners-grid silver-grid">
        {[
          "dina_1.png",
          "dina_2.png",
          "gift.png",
          "silver_4.png",
          "intern.png",
          "gift_traders.png",
          "formula.png",
          "hi.png",
          "many_1.png",
          "cloud.png",
          "Saral.png",
          "go.png",
          "mnc_group.png",
          "to.png",
          "finy.png",
          "due.png",
          "ahrms.png",
          "vr.png",
        ].map((img, i) => (
          <div className={`partner-card${img === "formula.png" ? " formula-card" : ""}`} key={i}>
            <img src={`${IMG}/${img}`} alt="Silver Partner" />
          </div>
        ))}
      </div> */}

      <h2 className="partners-heading-event secondary">
        ECOSYSTEM <span>PARTNERS</span>
      </h2>
      <div className="partners-grid four-col">
        {/* <div className="partner-item knowledge-partner move-upp">
          <h3 className="partner-title">Association Partner</h3>
          <div className="partner-card">
            <img src={`${IMG}/co_host.png`} alt="Partner" />
          </div>
        </div> */}
        <div className="partner-item knowledge-partner">
          <h3 className="partner-title move-right-title">Knowledge Partners</h3>
          <div className="partner-card">
            <img src={`${IMG}/dina_4.png`} alt="Partner" />
          </div>
        </div>
        {/* <div className="partner-item knowledge-partner move-up">
          <h3 className="partner-title"></h3>
          <div className="partner-card">
            <img src={`${IMG}/knowledge.png`} alt="Partner" />
          </div>
        </div> */}
        {/* <div className="partner-item event-partner">
          <h3 className="partner-title">Event Partner</h3>
          <div className="partner-card">
            <img src={`${IMG}/dina_6.png`} alt="Partner" />
          </div>
        </div> */}
        {/* <div className="partner-item community-partner">
          <h3 className="partner-title">Community Partners</h3>
          <div className="partner-card">
            <img src={`${IMG}/community_2.png`} alt="Partner" />
          </div>
        </div> */}
        {/* <div className="partner-item move-down">
          <h3 className="partner-title"></h3>
          <div className="partner-card">
            <img src={`${IMG}/community_5.png`} alt="Partner" className="community-logo" />
          </div>
        </div> */}
        {/* <div className="partner-item">
          <h3 className="partner-title"></h3>
          <div className="partner-card">
            <img src={`${IMG}/community_7.png`} alt="Partner" />
          </div>
        </div> */}
        {/* <div className="partner-item">
          <h3 className="partner-title"></h3>
          <div className="partner-card">
            <img src={`${IMG}/wlf_5.png`} alt="Partner" className="partner-logo" />
          </div>
        </div> */}
        {/* <div className="partner-item move-left-mobile">
          <h3 className="partner-title"></h3>
          <div className="partner-card">
            <img src={`${IMG}/community_8.png`} alt="Partner" />
          </div>
        </div> */}
        {/* <div className="partner-item move-left-mobile">
          <h3 className="partner-title"></h3>
          <div className="partner-card">
            <img src={`${IMG}/commu_9.jpeg`} alt="Partner" />
          </div>
        </div> */}
        {/* <div className="partner-item move-left-mobile">
          <h3 className="partner-title"></h3>
          <div className="partner-card">
            <img src={`${IMG}/uvagai.png`} alt="Partner" />
          </div>
        </div> */}
        {/* <div className="partner-item move-left-mobile">
          <h3 className="partner-title"></h3>
          <div className="partner-card">
            <img src={`${IMG}/bpp.png`} alt="Partner" />
          </div>
        </div> */}
        <div className="partner-item mental-partner">
          <h3 className="partner-title">Mental Wellness Partner</h3>
          <div className="partner-card">
            <img src={`${IMG}/dina_5.png`} alt="Partner" />
          </div>
        </div>
        <div className="partner-item media-partner">
          <h3 className="partner-title">Media Partners</h3>
          <div className="partner-card">
            <img src={`${IMG}/dina_3.png`} alt="Partner" />
          </div>
        </div>
         <div className="partner-item move-up-mobile venue-card">
  <h3 className="partner-title">Venue Partner</h3>
  <div className="partner-card">
    <img src={`${IMG}/venue.jpeg`} alt="Partner" />
  </div>
</div>
        {/* <div className="partner-item metro-partner">
          <div className="partner-card">
            <img src={`${IMG}/metro.png`} alt="Partner" />
          </div>
        </div> */}
        {/* <div className="partner-item support-partner">
          <h3 className="partner-title">Support Partner</h3>
          <div className="partner-card">
            <img src={`${IMG}/en.png`} alt="Partner" />
          </div>
        </div> */}
      </div>
    </div>
  </section>



  {/* 
      <div className="cta-right">
        <h3>DELEGATE PASS REGISTRATION</h3>
        <a href="#tickets" className="ticket-btn4">
          <img src={`${IMG}/get.png`} alt="Ticket Icon4" className="ticket-icon4" />
          <span>Get Ticket</span>
        </a>
      </div>
    </div>
  </section>

  <section className="event-info-section">
    <div className="container">
      <h2 className="event-title">Where and When</h2>

      <div className="event-info-wrapper">
        <div className="event-images top-images">
          <img src={`${IMG}/venue_1.jpeg`} alt="" />
          <img src={`${IMG}/venue_2.png`} alt="" />
        </div>

        <div className="event-image-large">
          <img src={`${IMG}/cctv.jpeg`} alt="" />
        </div>

        <div className="event-details">
          <h3>Date and Time</h3>
          <p className="date">11th July, 2026 (Saturday)</p>
          <p className="time">9:30 AM to 5:00 PM</p>

          <h3>Venue</h3>
          <p className="venue">
            Chennai Trade Centre,
            <br />
            Nandambakkam,
            <br />
            Chennai, Tamil Nadu &ndash; 600 089
          </p>
        </div>
      </div>
    </div>
  </section>

  <section className="event-map-section">
    <div className="container">
      <div className="map-wrapper">
        <iframe
          title="Venue Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.3282303364335!2d80.18837767308102!3d13.014757887304592!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267345cb07d5b%3A0x7d6459212d295bdf!2sChennai%20Trade%20Centre%20-%20Nandambakkam!5e0!3m2!1sen!2sin!4v1770627525230!5m2!1sen!2sin"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  </section>

  <div className="container">
    <section id="past" className="mt-5">
      <h2
        className="text-center"
        style={{ color: "#12037f", fontFamily: "Dosis, sans-serif", fontWeight: 700 }}
      >
        Previous Events
      </h2>
      <div className="row mt-4 mb-4">
        <PastEventCard
          img="2U2A0220.jpg"
          title="Annual TN HR Summit 2025"
          date="December 20, 2025 - 9:30 AM"
          venue="Hilton Hotel, Chennai."
          link="tn_hr_summit_2025_details.php"
        />
        <PastEventCard
          img="316A7696.JPG"
          title="HR Confluence 2025"
          date="August 23, 2025 - 9:30 AM"
          venue="Zone by The Park Hotel, Coimbatore."
          link="hr_confluence_2025_details.php"
        />
        <PastEventCard
          img="HRF2025_BG_1.jpg"
          title="HR Festival 2025"
          date="July 05, 2025 - 9:30 AM"
          venue="Chennai Trade Centre, Chennai."
          link="hr_festival_2025_details.php"
        />
        <PastEventCard
          img="hr_conference_2025_bg.JPG"
          title="HR Conference 2025"
          date="February 22, 2025 - 9:30 AM"
          venue="Hotel Grand Mercure, Bengaluru."
          link="hrconference2025details.php"
        />
      </div>
    </section>
  </div>
  
  */}
</>
    </>
  );
}

/* ---------------- Small reusable pieces ---------------- */

function CountdownItem({ label, value, offset, circleId }) {
  return (
    <div className="countdown-item">
      <div className="circle">
        <svg>
          <circle className="circle-bg" cx="65" cy="65" r="40"></circle>
          <circle
            className="circle-progress"
            cx="65"
            cy="65"
            r="40"
            id={circleId}
            style={{
              strokeDasharray: 2 * Math.PI * 40,
              strokeDashoffset: offset,
            }}
          ></circle>
        </svg>
        <div className="countdown-number">{value}</div>
      </div>
      <div className="countdown-label">{label}</div>
    </div>
  );
}

function StatCard({ iconClass, icon, number, label }) {
  return (
    <div className="stat-card">
      <div className="stat-top">
        <div className={iconClass}>
          <img src={`${IMG}/${icon}`} alt="Day" />
        </div>
        <div className="stat-number">{number}</div>
      </div>
      <div className="stat-text">
        <strong>{label}</strong>
      </div>
    </div>
  );
}

function HighlightCard({ img, title }) {
  return (
    <div className="highlight-card">
      <div className="highlight-image">
        <img src={`${IMG}/${img}`} alt={title} />
      </div>
      <div className="highlight-title">{title}</div>
    </div>
  );
}

function WhyPill({ icon, text }) {
  return (
    <div className="why-pill">
      <span className="why-icon">
        <img src={`${IMG}/${icon}`} alt="" />
      </span>
      <span className="why-text">{text}</span>
    </div>
  );
}

function SpeakerCard({ linkedin, photo, name, role, company }) {
  return (
    <div className="spk-card">
      <a href={linkedin} className="spk-linkedin" target="_blank" rel="noreferrer" aria-label={`${name} LinkedIn Profile`}>
        <img src={`${IMG}/speker_lin.png`} alt="LinkedIn" />
      </a>
      <div className="spk-photo">
        <img src={`${IMG}/${photo}`} alt="Speaker Name" />
      </div>
      <div className="spk-info">
        <h3 className="spk-name">{name}</h3>
        <p className="spk-role">{role}</p>
        <p className="spk-company">{company}</p>
      </div>
    </div>
  );
}

function SpeakerBox({ img, name, extraClass = "" }) {
  return (
    <div className={`speaker-box ${extraClass}`.trim()}>
      <div className="speaker-image">
        <img src={`${IMG}/${img}`} alt="Speaker Image" />
      </div>
      <div className="speaker-details">
        <h4 className="speaker-name">{name}</h4>
      </div>
    </div>
  );
}

function PartnerLink({ href, img, imgClass = "" }) {
  return (
    <a href={href} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
      <div className="partner-card">
        <img src={`${IMG}/${img}`} alt="Silver Sponsor" className={imgClass} />
      </div>
    </a>
  );
}

function PastEventCard({ img, title, date, venue, link }) {
  return (
    <div className="col-md-3 mb-4">
      <div className="card h-100">
        <img src={`${IMG}/${img}`} className="card-img-top img-fluid" alt="Past Event" loading="lazy" />
        <div className="card-body d-flex flex-column">
          <h6 className="card-title text-center mb-2">{title}</h6>
          <p className="card-text mb-2 mt-auto">
            <i className="fas fa-calendar-alt me-2"></i> {date}
          </p>
          <p className="card-text mb-2">
            <i className="fas fa-map-marker-alt me-2"></i> {venue}
          </p>
          <div className="mt-auto">
            <div className="row justify-content-center">
              <div className="col-auto">
                <a href={link} className="btn mb-3" style={{ backgroundColor: "#12037f", color: "white" }}>
                  Know More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}